"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableOptions = exports.getTableWeight = exports.getTableReferenceOptions = exports.getNamedTableOptions = exports.getTable = exports.getTableNames = void 0;
var utils_1 = require("./utils");
var path_1 = __importDefault(require("path"));
var tables = {};
var isInitialized = false;
function initAvailableTables(files) {
    for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
        var file = files_1[_i];
        var name = path_1.default.basename(file, ".json");
        tables[name] = { w: 0, options: [] };
    }
    isInitialized = true;
}
function importTable(tableName, r) {
    var name = path_1.default.basename(tableName, ".json");
    var table = r(tableName);
    var totalWeight = 0;
    var options = table.map(function (row) {
        var w = row.w > 0 ? row.w : 0;
        totalWeight += w;
        return __assign(__assign({}, row), { w: w, v: utils_1.getGroups(row.v) || [], original: row.v });
    });
    tables[name].options = options;
    tables[name].w = totalWeight;
}
function ensureTablesAreInitialized() {
    if (!isInitialized) {
        if (process.env.NODE_ENV === "test") {
            var fs = require("fs");
            var dir_1 = path_1.default.join(__dirname, "./tables");
            var dirContent = fs
                .readdirSync(dir_1)
                .filter(function (f) { return f.endsWith(".json"); });
            initAvailableTables(dirContent);
            for (var _i = 0, dirContent_1 = dirContent; _i < dirContent_1.length; _i++) {
                var table = dirContent_1[_i];
                // eslint-disable-next-line
                importTable(table, function (t) { return require(path_1.default.join(dir_1, t)); });
            }
        }
        else {
            var r_1 = require.context("./tables/", false, /\.json$/);
            initAvailableTables(r_1.keys());
            r_1.keys().forEach(function (key) {
                importTable(key, r_1);
            });
        }
    }
}
function getTableNames() {
    ensureTablesAreInitialized();
    return Object.keys(tables);
}
exports.getTableNames = getTableNames;
function getTable(tableName) {
    ensureTablesAreInitialized();
    if (!(tableName in tables)) {
        throw new Error("Unable to find table [" + tableName + "]");
    }
    return tables[tableName];
}
exports.getTable = getTable;
function getNamedTableOptions(tableName) {
    var options = getTable(tableName).options;
    return options;
}
exports.getNamedTableOptions = getNamedTableOptions;
function getTableReferenceOptions(tableName) {
    var options = getTable(tableName).options;
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var opt = options_1[_i];
        if (!("table" in opt)) {
            throw new Error("Missing \"table\" property in table " + tableName + " option " + opt.original);
        }
    }
    return options;
}
exports.getTableReferenceOptions = getTableReferenceOptions;
function getTableWeight(tableName) {
    return getTable(tableName).w;
}
exports.getTableWeight = getTableWeight;
function getTableOptions(tableName) {
    return getTable(tableName).options;
}
exports.getTableOptions = getTableOptions;
